window.ActionPlan = Block.extend({

    initialize: function(app, data, $dom, xml) {
        Block.prototype.initialize.call(this, app, data, $dom, xml);

        this.actionsManager = this.app.getComponent("ActionsManager");
    },

    render: function() {
        var content = this.getContent(this.data);
        this.$el.html(content);
        this.$empty = this.$el.find(".empty");

        this.updateEmpty();
        this.setupButtons();

        OverviewAnimation.animateIn(this.$el.find(".overview"));
    },

    setupButtons: function() {
        var addButton = new Button({
            el: this.$el.find(".add-button")
        });
        this.listenTo(addButton, "onClick", _.debounce(this.handleAddClicked, 500, true));

        var finishButton = new Button({
            el: this.$el.find(".finish-button")
        });
        this.listenTo(finishButton, "onClick", _.debounce(this.handleFinishClicked, 500, true));

        this.$el.find(".delete-button").each(function(i, item) {
            var deleteButton = new Button({
                el: $(item)
            });
            this.listenTo(deleteButton, "onClick", _.debounce(this.handleDeleteClicked, 500, true));
        }.bind(this));
    },

    handleAddClicked: function() {
        if (this.actionsManager.canAddAction()) {
            this.app.router.changeGlobalSlide("actionform");
        } else {
            this.actionsManager.showMaxWarningDialog();
        }
    },

    handleFinishClicked: function() {
        if (this.actionsManager.getActions().length < ActionsManager.MIN_ACTIONS) {
            this.actionsManager.showMinWarningDialog();
            return;
        }

        this.showFinishDialog();
    },

    handleDeleteClicked: function(e) {
        var $action = $(e.target).parent();

        this.showDeleteDialog($action);
    },

    getContent: function(data) {
        return Handlebars.templates["actionplan/actionplan"](data);
    },

    getData: function($xml, language) {
        var data = {};
        data.actions = [];
        data.title = this.blockData.title();

        var actions = this.actionsManager.getActions();
        _.each(actions, function(action) {
            data.actions.push(action.attributes);
        });

        data.emptyDescription = LanguageManager.getString("empty_action_plan");
        data.emptyImageAlt = LanguageManager.getString("empty_action_plan_alt");
        data.finishLabel = LanguageManager.getString("finish");
        data.addActionLabel = LanguageManager.getString("add_action");
        data.finishLabel = LanguageManager.getString("finish");
        data.deleteLabel = LanguageManager.getString("delete");

        return data;
    },

    finish: function() {
        this.complete();
        this.app.storage.setItem(ActionsManager.ACTION_PLAN_CONFIRMED_KEY, true);
        this.trigger("onActionPlanFinished", {target: this})
        this.app.router.next();
    },

    showFinishDialog: function($action) {
        this.bootbox = new AccessibleBootbox({
            title: LanguageManager.getString('plan_created'),
            message: LanguageManager.getString('plan_created_message'),
            animate: true,
            buttons: {
                ok: {
                    label: LanguageManager.getString('got_it'),
                    className: "btn-primary",
                    callback: function() {
                        if (this.bootbox !== undefined) {
                            this.bootbox.destroy();
                        }
                        this.bootbox = undefined;
                        this.finish();
                    }.bind(this)
                }
            }
        });

        this.bootbox.popIn();
    },

    showDeleteDialog: function($action) {
        this.bootbox = new AccessibleBootbox({
            title: LanguageManager.getString('confirm_delete_title'),
            message: LanguageManager.getString('confirm_delete_message'),
            animate: true,
            buttons: {
                ok: {
                    label: LanguageManager.getString('confirm'),
                    className: "btn-primary",
                    callback: function() {
                        if (this.bootbox !== undefined) {
                            this.deleteAction($action);
                            this.bootbox.destroy();
                        }
                        this.bootbox = undefined;
                    }.bind(this)
                },
                cancel: {
                    label: LanguageManager.getString('cancel'),
                    callback: function() {
                        if (this.bootbox !== undefined) {
                            this.bootbox.destroy();
                        }
                        this.bootbox = undefined;
                    }.bind(this)
                }
            }
        });
        this.bootbox.popIn();
    },

    deleteAction: function($action) {
        var id = $action.data("number");
        this.actionsManager.removeAction(id);
        $action.remove();

        this.updateEmpty();
    },

    updateEmpty: function() {
        var isEmpty = this.actionsManager.getActions().length > 0;
        this.$empty.toggle(!isEmpty);
    },

    handleSuspend: function() {
        Block.prototype.handleSuspend.call(this);

        this.stopListening(null, "onClick");
    },

    handleRestore: function() {
        Block.prototype.handleRestore.call(this);

        this.data = this.getData();
        this.render();
    }
});
